/** Entry point of the phase E taroko package (Taroko Gorge and Qixingtan, map hualien.ts). Imported once from main.ts. */
import '../render/propsHualien';
import '../render/propsTaroko';
import './taroko';
import { registerNpcs } from '../world/npcs';
import { NPCS_TAROKO } from '../world/npcsTaroko';

registerNpcs(NPCS_TAROKO);
